import { ApiRoutes, AppPaginationOptions, QueryError, WithPagination } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { Domain, RobotsFormFields, RobotsQueryKeys } from '@/modules/Domains';

export const useGetAllRobotsQuery = (siteId: string, paginationOptions: AppPaginationOptions) =>
  buildQuery<
    WithPagination<(Pick<Domain, 'id' | 'name'> & { isRobots: boolean; })
      >, QueryError>([RobotsQueryKeys.GetAllDomains, siteId, paginationOptions], async () => {
        const { data } = await apiExecutor.get(ApiRoutes.Robots.replace(':siteId', siteId), {
          params: paginationOptions
        });
        return data;
      });

export const useGetByIdRobotsQuery = (siteId: string, domainId: string) =>
  buildQuery<
    Pick<Domain, 'id' | 'robots'>,
    QueryError
  >([RobotsQueryKeys.GetById, siteId, domainId], async () => {
    const { data } = await apiExecutor.get(ApiRoutes.RobotsById.replace(':siteId', siteId).replace(':domainId', domainId));
    return data;
  });

export const useEditRobotsMutation = (siteId: string, domainId: string) =>
  buildMutation<void, QueryError, Partial<RobotsFormFields>>(
    [RobotsQueryKeys.Edit, siteId, domainId],
    async (postData) => {
      const { data } = await apiExecutor.patch<void>(ApiRoutes.RobotsById.replace(':siteId', siteId).replace(':domainId', domainId),
        postData
      );
      return data;
    }
  );
